import { compose, withProps, branch, renderNothing } from 'recompose';
import { usePortletConfig } from 'js/components/system/Portlet';
import { countDownModeTypes } from '../../constants';
import withCountDown from './withCountDown';
import { minsToRaw } from './helpers';

export default compose(
    withCountDown,
    branch(
        ({ isCompleted }) => isCompleted,
        renderNothing
    ),
    branch(
        ({ modeType }) => modeType,
        withProps(
            ({ modeType, timeTillEnd }) => {
                const { countdownBeforeEnd, countdownBeforeStart } = usePortletConfig();
                return {
                    isHighlighted: modeType === countDownModeTypes.START
                        ? Boolean(countdownBeforeStart) && timeTillEnd.raw <= minsToRaw(countdownBeforeStart)
                        : Boolean(countdownBeforeEnd) && timeTillEnd.raw <= minsToRaw(countdownBeforeEnd)
                };
            }
        )
    )
);

